// extracted by mini-css-extract-plugin
export var overlay = "Modal-module--overlay--WSsyO";
export var modal = "Modal-module--modal--1uszs";
export var close = "Modal-module--close--TWnXE";
export var content = "Modal-module--content--3-4_Y";
export var noPadding = "Modal-module--noPadding--268tf";
export var simple = "Modal-module--simple--3DKgl";